import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateExternalMatch } from "../api/MatchApiProvider";
import { useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { ExternalMatchForm } from "./ExternalMatchForm";
export const CreateExternalMatch = () => {
    const { id: teamId } = useNumericParams();
    const { data: userTeamPermissions, isLoading: userTeamPermissionsIsLoading, error: userTeamPermissionsError, } = useRetrieveUserTeamPermissions({ teamId });
    const { canModify = false } = userTeamPermissions || {};
    const { isLoading: useRetrieveTeamIsLoading, error: useRetrieveTeamError, data: team, } = useRetrieveTeam({ id: teamId, enabled: canModify });
    const [loading, setLoading] = useState(false);
    const [mutationError, setError] = useState(undefined);
    const navigate = useNavigate();
    const mutation = useCreateExternalMatch({
        team,
        onMutate: () => {
            setLoading(true);
        },
        onSuccess: (data) => {
            const externalMatch = data.data;
            return navigate(`/teams/${externalMatch.team}/external-matches/${externalMatch.id}/`);
        },
        onError: (error) => {
            setLoading(false);
            setError(error);
        },
    });
    const onSubmit = (externalMatch) => {
        mutation.mutate(externalMatch);
    };
    if (userTeamPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userTeamPermissionsError) {
        return _jsx(ErrorView, { error: userTeamPermissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (loading || useRetrieveTeamIsLoading) {
        return _jsx(Loading, {});
    }
    if (useRetrieveTeamError || !team) {
        return _jsx(ErrorView, { error: useRetrieveTeamError });
    }
    return (_jsxs(React.Fragment, { children: [mutationError && (_jsxs(Alert, { variant: "outlined", severity: "error", children: ["Failed to create match \u2014 ", mutationError.message, "!"] })), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Create External Match for ", team.name] }) }), _jsx(ExternalMatchForm, { team: team, onSubmit: onSubmit })] }));
};
